import { EntityAttendance } from "../../entity/EntityAttendance";

export class DtoAttendancesDeleteRes extends EntityAttendance {
  public message: string | null = null;
}
